import { ChatChannel } from '../enums/chat-channel.enum'
import { TypeCampaign } from '../enums/type-campaign.enum'

interface ChatCampaignLike {
  type?: TypeCampaign | string | null
  chat_channels?: (ChatChannel | string)[] | null
}

export const isChatCampaign = (campaign: ChatCampaignLike): boolean =>
  campaign.type === TypeCampaign.CHAT

// Una campaña CHAT sin canales guardados es de WhatsApp: es el único canal que
// existía antes de que las campañas tuvieran canales.
export const getChatChannels = (campaign: ChatCampaignLike): ChatChannel[] => {
  if (!isChatCampaign(campaign)) return []
  const channels = (campaign.chat_channels ?? []) as ChatChannel[]
  return channels.length ? channels : [ChatChannel.WHATSAPP]
}

export const hasChatChannel = (campaign: ChatCampaignLike, channel: ChatChannel): boolean =>
  getChatChannels(campaign).includes(channel)

// Campañas que pueden recibir lo exclusivo de WhatsApp: rutas de Gupshup,
// plantillas y envíos masivos.
export const isWhatsappChatCampaign = (campaign: ChatCampaignLike): boolean =>
  hasChatChannel(campaign, ChatChannel.WHATSAPP)
